import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetUsersSaga() {
    yield put(appActions.USERS_RESET_SUCCESS());
}

function* watchUsersUpdateRequest() {
    yield takeLatest(
        appActions.USERS_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/user/update',
                appActions.USERS_UPDATE_SUCCESS,
                appActions.USERS_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchUsersCreateRequest() {
    yield takeLatest(
        appActions.USERS_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/user/save',
                appActions.USERS_CREATE_SUCCESS,
                appActions.USERS_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchUsersDeleteRequest() {
    yield takeLatest(
        appActions.USERS_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                `communication/v1/user`,
                appActions.USERS_DELETE_SUCCESS,
                appActions.USERS_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchUsersGetAllRequest() {
    yield takeLatest(
        appActions.USERS_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/user',
                appActions.USERS_GET_ALL_SUCCESS,
                appActions.USERS_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* usersWatcher() {
    yield* watchUsersUpdateRequest();
    yield* watchUsersCreateRequest();
    yield* watchUsersGetAllRequest();
    yield* watchUsersDeleteRequest();
    yield takeLatest(
        appActions.USERS_RESET_REQUEST.type,
        resetUsersSaga,
    );
    // Add other watchers here
}
